// Rendered within a refinement list and contains the checkbox that triggers the
// refinement

import React from "react";
import PropTypes from "prop-types";

import number from "helpers/number";
import ControlledCheckbox from "components/shared/ControlledCheckbox";

const propTypes = {
  Label: PropTypes.node.isRequired,
  count: PropTypes.number,
  handleRefine: PropTypes.func.isRequired,
  isRefined: PropTypes.bool,
  refineable: PropTypes.bool,
  value: PropTypes.string.isRequired
};

const defaultProps = {
  count: 0,
  isRefined: false,
  refineable: false
};

const RefineElement = (props) => {
  const isDisabled = props.count === 0;

  let containerClassName = "refine-element";
  if (isDisabled) containerClassName += " refine-element--disabled";
  return (
    <div className={containerClassName}>
      <div className="refine-element__left">
        <ControlledCheckbox
          checked={props.isRefined}
          disabled={isDisabled}
          name={props.value}
          onChange={(e) => {
            if (!props.refineable) {
              e.preventDefault();
            }
            props.handleRefine(props.value);
          }}
        >
          {props.Label}
        </ControlledCheckbox>
      </div>
      <span
        className={`refine-element__count${
          props.isRefined ? " refine-element__count--refined" : ""
        }`}
      >
        {number.commaSeparateNumber(props.count)}
      </span>
    </div>
  );
};

RefineElement.propTypes = propTypes;
RefineElement.defaultProps = defaultProps;

export default RefineElement;
